import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render E50 contact us page
 */
const E50ContactUsPage = (): React.ReactElement => {
  return (
    <div
      data-testid="e50-contact-us-page-component"
      className="font-public-sans"
    >
      <BlockTitle
        text="Contact Us"
        rootClassName="mt-3 mb-5 text-4xl md:text-6xl lg:text-8xl font-medium font-poppins"
      />

      <p className="mb-6">
        Information on the Enterprise 50 Awards is available during office
        hours.
      </p>

      <ul className="mb-6">
        <li>
          E50 Hotline:&nbsp;
          <a
            className="text-blue-175 underline hover:text-gray-750"
            target="_blank"
            rel="noreferrer"
            href="tel:+65 6507 1555"
          >
            +65 6507 1555
          </a>
        </li>
        <li>
          Email:&nbsp;
          <a
            className="text-blue-175 underline hover:text-gray-750"
            target="_blank"
            rel="noreferrer"
            href="mailto:enterprise50@kpmg.com.sg"
          >
            enterprise50@kpmg.com.sg
          </a>
        </li>
      </ul>
    </div>
  );
};

export default E50ContactUsPage;
